var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCloseButton = function SvgCloseButton(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 11.5,
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.476 12.5l3.42 3.42c.132.132.135.344.013.466l-.523.523c-.125.125-.332.121-.466-.013l-3.42-3.42-3.42 3.42c-.132.132-.344.135-.466.013l-.523-.523c-.125-.125-.121-.332.013-.466l3.42-3.42-3.42-3.42c-.132-.132-.135-.344-.013-.466l.523-.523c.125-.125.332-.121.466.013l3.42 3.42 3.42-3.42c.132-.132.344-.135.466-.013l.523.523c.125.125.121.332-.013.466l-3.42 3.42"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCloseButton);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close-button.f6e52070673cf473b0ebc003abfce006.svg";